import type { RecursivePartial } from '@freelancer/datastore';
import { toNumber } from '@freelancer/utils';
import type {
  MinimalTaskGroupSourceLinkApi,
  TaskGroupApi,
  TaskGroupSourceLinkApi,
} from 'api-typings/tasklist/tasklist';
import { WorkflowTypeApi } from 'api-typings/tasklist/tasklist';
import type {
  MinimalTaskGroupLinkedSource,
  TaskGroup,
  TaskGroupLinkedSource,
} from './task-group.model';

export function transformTaskGroup(
  taskGroup: TaskGroupApi,
  authId: string,
): TaskGroup {
  return {
    id: taskGroup.id,
    ownerId: taskGroup.owner_id,
    linkedSources: transformTaskGroupLinkedSources(taskGroup.linked_sources),
    status: taskGroup.status,
    name: taskGroup.name,
    description: taskGroup.description,
    createdTime: taskGroup.created_time * 1000,
    linkedSourcesMinimal: transformMinimalTaskGroupLinkedSources(
      taskGroup.linked_sources,
    ),
    workflowType: taskGroup.workflow_type ?? WorkflowTypeApi.NONE,
    userId: toNumber(authId),
  };
}

export function transformTaskGroupLinkedSources(
  linkedSources: readonly TaskGroupSourceLinkApi[],
): readonly TaskGroupLinkedSource[] {
  return linkedSources.map(ls => {
    return {
      id: ls.id,
      taskGroupId: ls.task_group_id,
      sourceId: ls.source_id,
      sourceType: ls.source_type,
      createdTime: ls.created_time * 1000,
    };
  });
}

export function transformMinimalTaskGroupLinkedSources(
  linkedSources: readonly TaskGroupSourceLinkApi[],
): readonly MinimalTaskGroupLinkedSource[] {
  return linkedSources.map(ls => {
    return {
      sourceId: ls.source_id,
      sourceType: ls.source_type,
    };
  });
}

export function transformLinkedSourcesToSnakeCase(
  linkedSources: readonly RecursivePartial<TaskGroupLinkedSource | undefined>[],
): readonly MinimalTaskGroupSourceLinkApi[] {
  return linkedSources.map(sources => {
    return {
      // We need to check sources is defined due to issues with RecursivePartial. We assume sourceId and
      // sourceType fields are defined. They should be and if they aren't we fail loudly, rather than filtering
      source_id: sources?.sourceId,
      source_type: sources?.sourceType,
    } as MinimalTaskGroupSourceLinkApi;
  });
}
